import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { ChatFooter } from "../chat-footer";
import { ChatHeader } from "../chat-header";
import { ChatMessages } from "../chat-messages";
import EmptyState from "@/assets/icons/empty_state.svg?react";
import { useSupportContext } from "@/stores";

const SupportChat: FC = () => {
  const { currentChat } = useSupportContext();

  if (!currentChat) {
    return (
      <Stack spacing={4} alignItems={"center"} width={"100%"} mt={24}>
        <EmptyState />
        <Typography variant="h5">Select any feedback</Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="column" height="100%" justifyContent="space-between">
      <ChatHeader />
      <Stack sx={{ flex: 1, justifyContent: "flex-end", overflow: "scroll" }}>
        <ChatMessages />
      </Stack>
      <ChatFooter />
    </Stack>
  );
};

export { SupportChat };
